import { dateToIso } from "@/src/utils/datePicker";

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/** Purchase date cannot be after today. */
export function getPurchaseDateMax(): string {
  return dateToIso(new Date());
}

/** Warranty end must be on or after the purchase date (allows past warranty dates). */
export function getWarrantyEndMin(purchaseDate: string): string | undefined {
  const trimmed = purchaseDate.trim();
  if (ISO_DATE_REGEX.test(trimmed)) {
    return trimmed;
  }
  return undefined;
}

export function isIsoDateString(value: string): boolean {
  return ISO_DATE_REGEX.test(value.trim());
}
